// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1pCpa","tab":"Tabs_tab__B68tC","tabActive":"Tabs_tabActive__1kPvM"};